import { State } from 'src/types'
import { normalWristBelt } from './normalWristBelt'

export const wristBeltDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isThumbIntegrated = state?.beltType?.value === 'thumbIntegrated'
  const isBelt = !isThumbIntegrated
  if (isBelt) {
    normalWristBelt(ctx, state.listBelt.color, state.stitch.color)
  }
}
